// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

let gqlEndpoint = "";
if (process.env.VUE_APP_API_ENDPOINT === "production") {
  gqlEndpoint =
    "https://gtopc7xxwbbcpou4indsosya3u.appsync-api.ap-northeast-1.amazonaws.com/graphql";
} else {
  gqlEndpoint =
    "https://33hrszhzy5bi3fjdyov6plqbfm.appsync-api.ap-northeast-1.amazonaws.com/graphql";
  // "https://gtopc7xxwbbcpou4indsosya3u.appsync-api.ap-northeast-1.amazonaws.com/graphql";
}

const awsmobile = {
  Auth: {
    identityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_ID,
    region: "ap-northeast-1",
    userPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_ID
  },
  aws_appsync_graphqlEndpoint: gqlEndpoint,
  aws_appsync_region: "ap-northeast-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS"
};

// console.log(awsmobile);
export default awsmobile;
